import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../Vas';

import { ExtendedButton,TextField,MessageBox } from 'component-lib';

import { AccountsModel, RequestAjaxClass } from 'models-lib';

import { CheckEmail } from 'utils-lib';

class ResetPassword  extends Component {

    constructor(props)
    {
        super(props);
        this.AccountsModel = new AccountsModel([this]);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "ResetAccounts"){
          $("#LoadingIcon").removeClass().addClass('hide');
          me.Close();
          Vas.GetView('ResetPassworsSuccess');
        }
      });
    }

    ResetPassword(){
        //let result = this.refs.EMail.getValid();
        let result = false;
        if(document.getElementById('EMail').value.length > 0 && CheckEmail.Check(document.getElementById('EMail').value) === true){
          result = true;
        }
        if (result === true){
            $("#LoadingIcon").removeClass().addClass('loaderSmall');
            
            this.Request.setAuth(false);
            this.Request.setApiKey(Vas.ApiKey);
            this.Request.setApiUrl(Vas.ApiUrl);
            this.Request.setErrorHandler(()=>{
              $("#LoadingIcon").removeClass().addClass('hide');
            });
            this.AccountsModel.SetRequest(this.Request);

            this.AccountsModel.AccountReset($('#EMail').val());
        }else{
          ReactDOM.render(<MessageBox
            AppURL={Vas.ApplicationUrl}
            Title={Vas.Resources.Titles["Note"]}
            Message={Vas.Resources.Labels["NotValidEmail"]} /> , document.getElementById('messageContainer'));
        }
    }

    Close(){
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        $("#Content").css("opacity", "1");
    }

    render()
    {
       return (<div className={"form"} style={{width:'350px'}}>
           <table>
             <thead>
               <tr>
                 <th>
                  {Vas.Resources.Labels["ResetPassword"]}
                 </th>
                 <th>
                 <div
                      id={"LoadingIcon"}
                      className={'hide'}
                      style={{ float:"right" }} />
                 </th>
               </tr>
             </thead>
             <tbody>
               <tr>
                 <td>
                   <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordForgottenText1"]}</div><br />
                 </td>
               </tr>
               <tr>
                 <td>
                   <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordForgottenText2"]}</div><br />
                 </td>
               </tr>
               <tr>
                 <td>
                   <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordForgottenText3"]}</div><br />
                 </td>
               </tr>
               <tr>
                 <td>
                 <TextField 
                     Editable={true} 
                     Id="EMail" 
                     IsRequired={true}
                     Label={Vas.Resources.Labels["Email"]} 
                     me={this} 
                     OnChange={()=>{this.setState({ Email: $("#email").val() }); }}
                     ref={"EMail"} 
                     Tooltip={Vas.Resources.Tooltips["Email"]} 
                     Width={250}
                    />
                   <br />
                 </td>
                 {/*<td>
                   <EmailField 
                      ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error)}}
                     ApiUrl={Vas.ApiUrl} 
                     ApiKey={Vas.ApiKey}
                     AppURL={Vas.ApplicationUrl} 
                     AnonymousToken={localStorage.getItem["anonymous_token"]} 
                     Editable={true} 
                     Id="EMail" 
                     IsRequired={true}
                     Label={Vas.Resources.Labels["Email"]} 
                     me={this} 
                     Modus={"notChecked"}
                     OnChange={()=>{this.setState({ Email: $("#email").val() }); }}
                     ref={"EMail"} 
                     Tooltip={Vas.Resources.Tooltips["Email"]} 
                     Token={localStorage.getItem["vas_token"]} 
                     Width={250}
                    />
                   <br />
                 </td>*/}
               </tr>
               <tr>
                 <td>
                   <ExtendedButton 
                     Usable={true}
                     ref={"btoChange"}
                     Text={Vas.Resources.Labels["ResetPassword"]}
                     OnClick={()=>{ this.ResetPassword();}}
                     style={{ margin: 25 }} />
                 </td>
               </tr>
             </tbody>
           </table>
         </div>
        );
    }
}
export default ResetPassword;
